<template>
    <v-navigation-drawer
      v-model="drawer"
      fixed
      color="#000"
      temporary
    >
      <v-list-item class="pt-4 pb-4" v-if="getIsLogin">
        <v-list-item-avatar color="#f3f3f3">
          <img v-if="avatar.type == 1" :src="avatar.content" alt="" />
          <div style="width: 100%;color: #111;" v-else>{{ avatar.content }}</div>
          <!-- <v-img src="https://randomuser.me/api/portraits/men/78.jpg"></v-img> -->
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{ avatar.userName }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item
          link
          @click="$router.replace('/')"
        >
          <v-list-item-content>
            <v-list-item-title>
              {{ $vuetify.lang.t("$vuetify.public.home") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          @click="$router.replace('/delivery')"
        >
          <v-list-item-content>
            <v-list-item-title>{{ $vuetify.lang.t("$vuetify.setting.dreivatives") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          @click="$router.replace('/contract')"
        >
          <v-list-item-content>
            <v-list-item-title>{{ $vuetify.lang.t("$vuetify.standardContract.contractTransaction") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          @click="$router.replace('/assets')"
        >
          <v-list-item-content>
            <v-list-item-title>{{ $vuetify.lang.t("$vuetify.setting.assets") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          @click="$router.replace('/invest')"
        >
          <v-list-item-content>
            <v-list-item-title>{{ $vuetify.lang.t("$vuetify.setting.liquidity") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
</template>

<script>
import {mapGetters} from "vuex"
export default {
  data () {
    return {
      drawer:false
    }
  },
  computed:{
    ...mapGetters(["getUserInfo",'getIsLogin']),
    avatar() {
      if (Object.keys(this.getUserInfo).length == 0) {
        return;
      }
      let nickName =
        this.getUserInfo.nickName ||
        this.getUserInfo.email ||
        this.getUserInfo.phone ||
        this.getUserInfo.address;
      let userName =
        this.getUserInfo.email ||
        this.getUserInfo.phone ||
        this.getUserInfo.address;
      if (this.getUserInfo.headerImg) {
        return {
          type: 1,
          content: this.getUserInfo.headerImg,
          userName,
        };
      }

      return {
        type: 2,
        content: nickName.slice(0, 1),
        userName,
      };
    },
  },
  props:{
    value:{
      type:Boolean,
      default:() => false
    }
  },
  methods:{
    close() {
      this.$emit('update:value',false)
    }
  },
  watch:{
    value(v) {
      this.drawer = v
    },
    drawer(v) {
      if(!v) {
        this.close()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-list-item {
  min-height: 50px;
}
</style>